import App from "./App.svelte"

export const app = new App({
    target: document.getElementById("content"),
})
